import { BaseModel } from "sjs-base-model";

export default class UserPutModel extends BaseModel {
  //USER PUT model
  data = {};
  status = "";

  constructor(data1) {
    super();

    this.update(data1);
  }
}
